import { sendEmailReq } from '../helpers/requestUtils';

export const sendEmail = (emails, fullname, ownEmail, message) => {
    return (dispatch, getState) => {
        const { tourId, tourType } = getState().app;

        sendEmailReq({
            recipient_emails: emails,
            sender_full_name: fullname,
            sender_email: ownEmail,
            sender_text_message: message,
            mode: tourType,
            form_type: 'send_tour'
        }, tourId);
    }
};
